import React from 'react';
import useIllustrationColor from '@cvent/blocks/hooks/useIllustrationColor';
import { SVGInterface } from '../images/SVGInterface';

function LightBackgroundSpotChatBubblesSVG({ color }: SVGInterface) {
  return (
    <>
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.9675 53.0569C87.3488 47.8807 121.435 47.1413 153.147 59.7405L153.141 59.7344C170.441 66.6042 180.345 81.9436 182.788 91.5796C185.157 100.929 183.392 116.036 178.153 123.223C175.286 127.156 171.629 130.345 167.397 132.907C137.767 150.836 79.9084 137.983 67.0581 133.708L67.0289 133.698C52.987 129.032 16.5213 116.914 8.07578 97.2098C8.03039 97.1038 7.98559 96.9981 7.94139 96.8926C-3.32994 69.9945 24.0446 58.4892 39.7134 55.5209C44.4444 54.6263 49.1987 53.7963 53.9675 53.0569Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.9915 46.6115H37.9913C35.683 46.7459 33.9183 48.7244 34.0526 51.0326L37.5638 111.59C37.7012 113.957 39.6038 115.455 41.6047 115.536C42.0294 115.553 42.4586 115.506 42.8763 115.391C43.6392 115.179 44.3638 114.737 44.9528 114.033L54.7537 102.315C55.6926 101.193 57.0285 100.479 58.4798 100.318C58.5766 100.307 58.6739 100.299 58.7716 100.293M58.7718 100.293L99.9146 97.9095L97.169 126.509C96.9858 128.371 98.3537 130.026 100.216 130.203L145.373 134.539C146.631 134.661 147.786 135.296 148.561 136.298L156.127 146.074C158.008 148.498 161.885 147.375 162.178 144.321L166.874 95.4515C167.058 93.589 165.69 91.9341 163.827 91.757L118.366 87.3896L115.983 46.2818C115.854 44.0569 114.011 42.337 111.811 42.3359C111.728 42.3359 111.645 42.3383 111.562 42.3431V42.3492L37.9915 46.6115"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.562 42.3492L37.9913 46.6115C35.683 46.7459 33.9183 48.7244 34.0526 51.0326L37.5638 111.59C37.7836 115.376 42.5223 116.94 44.9526 114.033L54.7535 102.315C55.755 101.118 57.2083 100.385 58.7716 100.293L114.731 97.051C117.039 96.9166 118.804 94.9381 118.67 92.6299L115.983 46.2818C115.849 43.9736 113.87 42.2088 111.562 42.3431V42.3492ZM82.2316 72.9125L56.2678 74.4186C54.7426 74.5071 53.5779 75.8153 53.6664 77.3404L53.6668 77.3465C53.7552 78.8717 55.0634 80.0364 56.5885 79.9479L82.5523 78.4418C84.0775 78.3533 85.2422 77.0452 85.1537 75.52L85.1534 75.5139C85.0649 73.9887 83.7568 72.824 82.2316 72.9125ZM55.6461 63.6662L99.8986 61.0991C101.424 61.0106 102.732 62.1753 102.82 63.7005L102.821 63.7066C102.909 65.2318 101.744 66.5399 100.219 66.6284L55.9669 69.1955C54.4417 69.2839 53.1335 68.1193 53.0451 66.5941L53.0447 66.588C52.9562 65.0628 54.1209 63.7547 55.6461 63.6662Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.9146 97.9097L114.731 97.0512C117.039 96.9169 118.804 94.9384 118.67 92.6301L118.366 87.3896L163.827 91.7571C165.69 91.9342 167.058 93.5891 166.874 95.4515L162.178 144.322C161.885 147.375 158.008 148.498 156.127 146.074L148.561 136.298C147.786 135.296 146.631 134.661 145.373 134.539L100.216 130.203C98.3537 130.026 96.9858 128.372 97.169 126.509L99.9146 97.9097ZM147.78 118.144L126.834 116.131C125.602 116.012 124.699 114.918 124.818 113.686C124.936 112.454 126.031 111.551 127.263 111.669L148.209 113.682C149.441 113.801 150.344 114.896 150.226 116.128C150.107 117.36 149.012 118.262 147.78 118.144ZM112.91 106.033L148.614 109.465C149.846 109.583 150.941 108.681 151.06 107.449C151.178 106.217 150.275 105.122 149.043 105.003L113.338 101.572C112.106 101.453 111.012 102.356 110.893 103.588C110.775 104.82 111.677 105.915 112.91 106.033Z"
        fill="white"
        fillOpacity="0.1"
      />
      <path
        d="M126.834 116.13L147.781 118.144C149.013 118.262 150.107 117.359 150.226 116.127C150.344 114.895 149.442 113.8 148.209 113.682L127.263 111.669C126.031 111.55 124.936 112.453 124.818 113.685C124.7 114.917 125.602 116.012 126.834 116.13Z"
        fill="white"
      />
      <path
        d="M112.91 106.033L148.614 109.465C149.846 109.583 150.941 108.68 151.06 107.448C151.178 106.216 150.275 105.121 149.043 105.003L113.338 101.571C112.106 101.453 111.012 102.356 110.893 103.588C110.775 104.82 111.678 105.914 112.91 106.033Z"
        fill="white"
      />
      <path
        d="M82.2317 72.9123L56.2679 74.4184C54.7428 74.5069 53.5781 75.815 53.6665 77.3402L53.6669 77.3463C53.7554 78.8715 55.0635 80.0362 56.5887 79.9477L82.5525 78.4415C84.0777 78.3531 85.2423 77.0449 85.1539 75.5197L85.1535 75.5136C85.065 73.9885 83.7569 72.8238 82.2317 72.9123Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M99.8988 61.0989L55.6464 63.666C54.1212 63.7544 52.9565 65.0626 53.045 66.5878L53.0453 66.5939C53.1338 68.119 54.4419 69.2837 55.9671 69.1952L100.22 66.6282C101.745 66.5397 102.909 65.2316 102.821 63.7064L102.821 63.7003C102.732 62.1751 101.424 61.0104 99.8988 61.0989Z"
        fill="white"
        fillOpacity="0.6"
      />
    </>
  );
}

function LightBackgroundSpotChatBubblesSmallSVG({ color }: SVGInterface) {
  return (
    <>
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7792 45.8264C64.0187 39.9192 96.4931 37.4243 126.407 49.3092L126.402 49.3042C140.681 54.9745 148.856 67.6356 150.872 75.5892C152.828 83.3058 151.371 95.7754 147.047 101.708C144.681 104.954 141.662 107.586 138.169 109.701C113.713 124.499 65.9561 113.89 55.3495 110.362L55.3254 110.354C43.7353 106.502 13.6365 96.5 6.66565 80.2363C-2.92596 57.8474 19.7955 48.2861 32.7792 45.8264Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3581 38.4734H31.358C29.4528 38.5843 27.9961 40.2173 28.107 42.1225L31.0052 92.1068C31.0959 93.6693 32.1191 94.7731 33.3703 95.1864C34.0811 95.4212 34.8656 95.4331 35.5945 95.1797C36.1487 94.987 36.6708 94.641 37.104 94.1229L45.1937 84.4506C45.9686 83.5245 47.0712 82.935 48.2692 82.8027C48.349 82.7938 48.4293 82.787 48.51 82.7823M48.5101 82.7823L82.4693 80.8146L80.2031 104.42C80.0519 105.958 81.1809 107.324 82.7182 107.47L119.991 111.048C121.029 111.149 121.982 111.673 122.622 112.5L128.867 120.569C130.419 122.57 133.62 121.643 133.862 119.123L137.738 78.7857C137.889 77.2484 136.76 75.8825 135.223 75.7364L97.6993 72.1315L95.7323 38.2012C95.6353 36.5341 94.3728 35.2105 92.7823 34.98C92.5551 34.947 92.3213 34.9364 92.0832 34.9503C92.0831 34.9503 92.0831 34.9503 92.083 34.9503V34.9553L31.3581 38.4734"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.083 34.9553L31.358 38.4734C29.4528 38.5843 27.9961 40.2173 28.107 42.1226L31.0052 92.1068C31.1866 95.2318 35.0978 96.5221 37.1039 94.1229L45.1935 84.4507C46.0201 83.4628 47.2197 82.8579 48.51 82.7823L94.6989 80.1059C96.6041 79.9951 98.0608 78.362 97.9499 76.4568L95.7322 38.2012C95.6213 36.296 93.9882 34.8394 92.083 34.9503V34.9553ZM67.8738 60.1821L46.4434 61.4253C45.1845 61.4983 44.2232 62.5781 44.2962 63.8369L44.2965 63.842C44.3695 65.1009 45.4492 66.0622 46.7081 65.9892L68.1385 64.746C69.3974 64.6729 70.3587 63.5932 70.2857 62.3343L70.2854 62.3293C70.2124 61.0704 69.1327 60.1091 67.8738 60.1821ZM45.9302 52.5503L82.456 50.4314C83.7149 50.3584 84.7947 51.3197 84.8677 52.5786L84.868 52.5836C84.941 53.8425 83.9797 54.9222 82.7208 54.9953L46.195 57.1141C44.9361 57.1871 43.8564 56.2258 43.7833 54.9669L43.783 54.9619C43.71 53.703 44.6713 52.6233 45.9302 52.5503Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.4692 80.8141L94.6988 80.1055C96.604 79.9946 98.0606 78.3615 97.9498 76.4563L97.699 72.1309L135.222 75.7358C136.76 75.8819 137.889 77.2478 137.738 78.7851L133.862 119.122C133.62 121.642 130.419 122.57 128.867 120.569L122.622 112.499C121.982 111.673 121.029 111.149 119.991 111.048L82.7181 107.469C81.1808 107.323 80.0518 105.957 80.203 104.42L82.4692 80.8141ZM121.978 97.5154L104.688 95.8537C103.672 95.756 102.926 94.8524 103.024 93.8354C103.122 92.8185 104.025 92.0734 105.042 92.1711L122.331 93.8328C123.348 93.9306 124.094 94.8342 123.996 95.8511C123.898 96.868 122.994 97.6131 121.978 97.5154ZM93.1952 87.5193L122.666 90.3518C123.683 90.4496 124.586 89.7044 124.684 88.6875C124.782 87.6706 124.037 86.767 123.02 86.6692L93.5491 83.8367C92.5322 83.739 91.6286 84.4841 91.5309 85.5011C91.4331 86.518 92.1783 87.4216 93.1952 87.5193Z"
        fill="white"
        fillOpacity="0.1"
      />
      <path
        d="M104.688 95.8537L121.978 97.5154C122.994 97.6131 123.898 96.868 123.996 95.8511C124.094 94.8342 123.348 93.9306 122.332 93.8328L105.042 92.1711C104.026 92.0734 103.122 92.8185 103.024 93.8354C102.926 94.8524 103.672 95.756 104.688 95.8537Z"
        fill="white"
      />
      <path
        d="M93.1952 87.5188L122.666 90.3513C123.683 90.4491 124.586 89.7039 124.684 88.687C124.782 87.6701 124.037 86.7665 123.02 86.6688L93.5492 83.8363C92.5323 83.7385 91.6287 84.4837 91.5309 85.5006C91.4332 86.5175 92.1783 87.4211 93.1952 87.5188Z"
        fill="white"
      />
      <path
        d="M67.8738 60.1812L46.4433 61.4244C45.1845 61.4974 44.2231 62.5772 44.2962 63.836L44.2965 63.8411C44.3695 65.1 45.4492 66.0613 46.7081 65.9883L68.1385 64.7451C69.3974 64.672 70.3587 63.5923 70.2857 62.3334L70.2854 62.3284C70.2124 61.0695 69.1327 60.1082 67.8738 60.1812Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M82.4561 50.4306L45.9303 52.5494C44.6714 52.6224 43.7101 53.7022 43.7831 54.961L43.7834 54.9661C43.8564 56.225 44.9362 57.1863 46.195 57.1133L82.7209 54.9944C83.9797 54.9214 84.9411 53.8416 84.868 52.5828L84.8677 52.5777C84.7947 51.3188 83.715 50.3575 82.4561 50.4306Z"
        fill="white"
        fillOpacity="0.6"
      />
    </>
  );
}

function DarkBackgroundSpotChatBubblesSVG({ color }: SVGInterface) {
  return (
    <>
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.9675 53.0569C87.3488 47.8807 121.435 47.1413 153.147 59.7405L153.141 59.7344C170.441 66.6042 180.345 81.9436 182.788 91.5796C185.157 100.929 183.392 116.036 178.153 123.223C175.286 127.156 171.629 130.345 167.397 132.907C137.767 150.836 79.9084 137.983 67.0581 133.708L67.0289 133.698C52.987 129.032 16.5213 116.914 8.07578 97.2098C8.03039 97.1038 7.98559 96.9981 7.94139 96.8926C-3.32994 69.9945 24.0446 58.4892 39.7134 55.5209C44.4444 54.6263 49.1987 53.7963 53.9675 53.0569Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.9915 46.6115H37.9913C35.683 46.7459 33.9183 48.7244 34.0526 51.0326L37.5638 111.59C37.7012 113.957 39.6038 115.455 41.6047 115.536C42.0294 115.553 42.4586 115.506 42.8763 115.391C43.6392 115.179 44.3638 114.737 44.9528 114.033L54.7537 102.315C55.6926 101.193 57.0285 100.479 58.4798 100.318C58.5766 100.307 58.6739 100.299 58.7716 100.293M58.7718 100.293L99.9147 97.9095L97.1691 126.509C96.9859 128.371 98.3538 130.026 100.216 130.203L145.374 134.539C146.631 134.661 147.786 135.296 148.561 136.298L156.127 146.074C158.008 148.498 161.885 147.375 162.179 144.321L166.874 95.4515C167.058 93.589 165.69 91.9341 163.827 91.757L118.366 87.3896L115.983 46.2818C115.854 44.0569 114.011 42.337 111.811 42.3359C111.728 42.3359 111.645 42.3383 111.562 42.3431V42.3492L37.9915 46.6115"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.562 42.3492L37.9913 46.6115C35.683 46.7459 33.9183 48.7244 34.0526 51.0326L37.5638 111.59C37.7836 115.376 42.5223 116.94 44.9526 114.033L54.7535 102.315C55.755 101.118 57.2083 100.385 58.7716 100.293L114.731 97.051C117.039 96.9166 118.804 94.9381 118.67 92.6299L115.983 46.2818C115.849 43.9736 113.87 42.2088 111.562 42.3431V42.3492ZM82.2318 72.9125L56.268 74.4186C54.7428 74.5071 53.5781 75.8153 53.6666 77.3404L53.6669 77.3465C53.7554 78.8717 55.0635 80.0364 56.5887 79.9479L82.5525 78.4418C84.0777 78.3533 85.2424 77.0452 85.1539 75.52L85.1536 75.5139C85.0651 73.9887 83.757 72.824 82.2318 72.9125ZM55.6463 63.6662L99.8987 61.0991C101.424 61.0106 102.732 62.1753 102.821 63.7005L102.821 63.7066C102.909 65.2318 101.745 66.5399 100.219 66.6284L55.967 69.1955C54.4419 69.2839 53.1337 68.1193 53.0452 66.5941L53.0449 66.588C52.9564 65.0628 54.1211 63.7547 55.6463 63.6662Z"
        fill="white"
        fillOpacity="0.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.9148 97.9097L114.731 97.0512C117.04 96.9169 118.804 94.9384 118.67 92.6301L118.366 87.3896L163.827 91.7571C165.69 91.9342 167.058 93.5891 166.875 95.4516L162.179 144.322C161.886 147.375 158.008 148.498 156.127 146.074L148.561 136.298C147.786 135.296 146.632 134.661 145.374 134.539L100.216 130.203C98.3539 130.026 96.9861 128.372 97.1693 126.509L99.9148 97.9097ZM147.781 118.144L126.834 116.131C125.602 116.012 124.7 114.918 124.818 113.686C124.937 112.454 126.031 111.551 127.263 111.669L148.21 113.682C149.442 113.801 150.344 114.896 150.226 116.128C150.108 117.36 149.013 118.262 147.781 118.144ZM112.91 106.033L148.615 109.465C149.847 109.583 150.942 108.681 151.06 107.449C151.178 106.217 150.276 105.122 149.044 105.003L113.339 101.572C112.107 101.453 111.012 102.356 110.894 103.588C110.775 104.82 111.678 105.915 112.91 106.033Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M126.834 116.13L147.781 118.144C149.013 118.262 150.107 117.359 150.226 116.127C150.344 114.895 149.442 113.8 148.209 113.682L127.263 111.669C126.031 111.55 124.936 112.453 124.818 113.685C124.7 114.917 125.602 116.012 126.834 116.13Z"
        fill="white"
      />
      <path
        d="M112.91 106.033L148.614 109.465C149.846 109.583 150.941 108.68 151.06 107.448C151.178 106.216 150.275 105.121 149.043 105.003L113.338 101.571C112.106 101.453 111.012 102.356 110.893 103.588C110.775 104.82 111.678 105.914 112.91 106.033Z"
        fill="white"
      />
      <path
        d="M82.2317 72.9123L56.2679 74.4184C54.7428 74.5069 53.5781 75.815 53.6665 77.3402L53.6669 77.3463C53.7554 78.8715 55.0635 80.0362 56.5887 79.9477L82.5525 78.4415C84.0777 78.3531 85.2424 77.0449 85.1539 75.5197L85.1535 75.5136C85.065 73.9885 83.7569 72.8238 82.2317 72.9123Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M99.8988 61.0989L55.6464 63.666C54.1212 63.7544 52.9565 65.0626 53.045 66.5878L53.0453 66.5939C53.1338 68.119 54.4419 69.2837 55.9671 69.1952L100.22 66.6282C101.745 66.5397 102.909 65.2316 102.821 63.7064L102.821 63.7003C102.732 62.1751 101.424 61.0104 99.8988 61.0989Z"
        fill="white"
        fillOpacity="0.6"
      />
    </>
  );
}

function DarkBackgroundSpotChatBubblesSmallSVG({ color }: SVGInterface) {
  return (
    <>
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7794 45.8264C64.0189 39.9192 96.4933 37.4243 126.407 49.3092L126.402 49.3042C140.681 54.9745 148.857 67.6356 150.873 75.5892C152.828 83.3058 151.372 95.7754 147.047 101.708C144.681 104.954 141.662 107.586 138.169 109.701C113.713 124.499 65.9562 113.89 55.3496 110.362L55.3255 110.354C43.7354 106.502 13.6367 96.5 6.66577 80.2363C-2.92584 57.8474 19.7956 48.2861 32.7794 45.8264Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3581 38.4734H31.3579C29.4527 38.5843 27.9961 40.2173 28.1069 42.1225L31.0051 92.1068C31.0958 93.6693 32.119 94.7731 33.3702 95.1864C34.0811 95.4212 34.8655 95.4331 35.5944 95.1797C36.1486 94.987 36.6707 94.641 37.104 94.1229L45.1936 84.4506C45.9168 83.5863 46.9256 83.0151 48.0309 82.8352C48.1888 82.8095 48.3486 82.7918 48.5099 82.7823M48.5101 82.7823L82.4693 80.8146L80.2031 104.42C80.0519 105.958 81.1809 107.324 82.7182 107.47L119.991 111.048C121.029 111.149 121.982 111.673 122.622 112.5L128.867 120.569C130.419 122.57 133.62 121.643 133.862 119.123L137.738 78.7857C137.889 77.2484 136.76 75.8825 135.223 75.7364L97.6992 72.1315L95.7323 38.2012C95.6352 36.5341 94.3727 35.2105 92.7822 34.98C92.5551 34.947 92.3212 34.9364 92.0831 34.9503C92.0831 34.9503 92.083 34.9503 92.0829 34.9503V34.9553L31.3581 38.4734"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.083 34.9553L31.3579 38.4734C29.4527 38.5843 27.9961 40.2173 28.1069 42.1226L31.0051 92.1068C31.1865 95.2318 35.0978 96.5221 37.1038 94.1229L45.1934 84.4507C46.02 83.4628 47.2196 82.8579 48.5099 82.7823L94.6988 80.1059C96.6041 79.9951 98.0607 78.362 97.9498 76.4568L95.7321 38.2012C95.6212 36.296 93.9882 34.8394 92.083 34.9503V34.9553ZM67.8739 60.1821L46.4434 61.4253C45.1846 61.4983 44.2232 62.5781 44.2963 63.8369L44.2966 63.842C44.3696 65.1009 45.4493 66.0622 46.7082 65.9892L68.1386 64.746C69.3975 64.6729 70.3588 63.5932 70.2858 62.3343L70.2855 62.3293C70.2125 61.0704 69.1328 60.1091 67.8739 60.1821ZM45.9303 52.5503L82.4561 50.4314C83.715 50.3584 84.7947 51.3197 84.8678 52.5786L84.8681 52.5836C84.9411 53.8425 83.9798 54.9222 82.7209 54.9953L46.1951 57.1141C44.9362 57.1871 43.8564 56.2258 43.7834 54.9669L43.7831 54.9619C43.7101 53.703 44.6714 52.6233 45.9303 52.5503Z"
        fill="white"
        fillOpacity="0.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.4693 80.8141L94.6988 80.1055C96.6041 79.9946 98.0607 78.3615 97.9498 76.4563L97.6991 72.1309L135.223 75.7358C136.76 75.8819 137.889 77.2479 137.738 78.7851L133.862 119.122C133.62 121.642 130.419 122.57 128.867 120.569L122.622 112.499C121.982 111.673 121.029 111.149 119.991 111.048L82.7182 107.469C81.181 107.323 80.0519 105.957 80.2032 104.42L82.4693 80.8141ZM121.978 97.5154L104.689 95.8537C103.672 95.756 102.927 94.8524 103.024 93.8355C103.122 92.8185 104.026 92.0734 105.043 92.1711L122.332 93.8328C123.349 93.9306 124.094 94.8342 123.996 95.8511C123.898 96.868 122.995 97.6132 121.978 97.5154ZM93.1954 87.5193L122.666 90.3518C123.683 90.4496 124.587 89.7044 124.684 88.6875C124.782 87.6706 124.037 86.767 123.02 86.6693L93.5494 83.8367C92.5325 83.739 91.6289 84.4841 91.5311 85.5011C91.4334 86.518 92.1785 87.4216 93.1954 87.5193Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M104.688 95.8537L121.978 97.5154C122.994 97.6131 123.898 96.868 123.996 95.8511C124.094 94.8342 123.348 93.9306 122.332 93.8328L105.042 92.1711C104.026 92.0734 103.122 92.8185 103.024 93.8354C102.926 94.8524 103.672 95.756 104.688 95.8537Z"
        fill="white"
      />
      <path
        d="M93.1952 87.5188L122.666 90.3513C123.683 90.4491 124.586 89.7039 124.684 88.687C124.782 87.6701 124.037 86.7665 123.02 86.6688L93.5492 83.8363C92.5323 83.7385 91.6287 84.4837 91.5309 85.5006C91.4332 86.5175 92.1783 87.4211 93.1952 87.5188Z"
        fill="white"
      />
      <path
        d="M67.8739 60.1812L46.4435 61.4244C45.1846 61.4974 44.2233 62.5772 44.2963 63.836L44.2966 63.8411C44.3696 65.1 45.4493 66.0613 46.7082 65.9883L68.1387 64.7451C69.3975 64.672 70.3589 63.5923 70.2858 62.3334L70.2855 62.3284C70.2125 61.0695 69.1328 60.1082 67.8739 60.1812Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M82.4561 50.4306L45.9303 52.5494C44.6714 52.6224 43.7101 53.7022 43.7831 54.961L43.7834 54.9661C43.8564 56.225 44.9362 57.1863 46.195 57.1133L82.7209 54.9944C83.9797 54.9214 84.9411 53.8416 84.868 52.5828L84.8677 52.5777C84.7947 51.3188 83.715 50.3575 82.4561 50.4306Z"
        fill="white"
        fillOpacity="0.6"
      />
    </>
  );
}

type SVGFeatureFlagSwitch = {
  color: string;
  flyoutStyle: boolean;
};

function LightSVG({ color, flyoutStyle }: SVGFeatureFlagSwitch) {
  return flyoutStyle ? (
    <LightBackgroundSpotChatBubblesSmallSVG color={color} />
  ) : (
    <LightBackgroundSpotChatBubblesSVG color={color} />
  );
}

function DarkSVG({ color, flyoutStyle }: SVGFeatureFlagSwitch) {
  return flyoutStyle ? (
    <DarkBackgroundSpotChatBubblesSmallSVG color={color} />
  ) : (
    <DarkBackgroundSpotChatBubblesSVG color={color} />
  );
}

type SVGProps = {
  flyoutStyle?: boolean;
};

export default function SpotChatBubblesSVG({ flyoutStyle }: SVGProps) {
  const { color, isLight } = useIllustrationColor();
  return (
    <svg
      width={flyoutStyle ? '156' : '189'}
      height={flyoutStyle ? '156' : '189'}
      viewBox={flyoutStyle ? '0 0 156 156' : '0 0 189 189'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
    >
      <title>Chat bubbles</title>
      {isLight ? (
        <LightSVG color={color} flyoutStyle={flyoutStyle} />
      ) : (
        <DarkSVG color={color} flyoutStyle={flyoutStyle} />
      )}
    </svg>
  );
}
